import { configureStore } from "@reduxjs/toolkit";
import { componentsReducer } from "./componentsSlice";
import { etudeSlice } from "./etudeSlice";

import rtkApi from "../store/api";
import { commonSlice } from "./commonSlice";
import { authSlice } from "./authSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    components: componentsReducer,
    common: commonSlice.reducer,
    etude: etudeSlice.reducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(rtkApi.middleware);
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
